// Lightweight image optimizer that routes external image URLs through wsrv.nl
// (a free Cloudflare-cached image proxy). It resizes and serves WebP on the fly,
// turning multi-MB PNGs into tens of KB WebP files with minimal quality loss.
//
// Usage:
//   <img src={img(url, 1000)} srcSet={srcSet(url)} sizes="(max-width: 768px) 100vw, 50vw" />
//
// Safe to call on every URL — local paths, data URIs and already-wrapped URLs
// are returned unchanged.

const WSRV = 'https://wsrv.nl/';

function shouldSkip(url) {
  if (!url || typeof url !== 'string') return true;
  if (url.startsWith('data:') || url.startsWith('blob:') || url.startsWith('/')) return true;
  if (url.startsWith(WSRV)) return true;
  if (url.includes('mondaine_style_logo_transparent')) return true;
  return false;
}

export function img(url, width = 1000, quality = 78) {
  if (shouldSkip(url)) return url;
  const params = new URLSearchParams({
    url,
    w: String(width),
    output: 'webp',
    q: String(quality),
    we: '', // "we" = enlarge=false (don't upscale beyond source)
    af: '', // adaptive filter for sharper down-scales
  });
  return `${WSRV}?${params.toString()}`;
}

// Responsive srcSet for the same image at multiple widths.
// Browser picks the smallest one that satisfies `sizes`.
export function srcSet(url, widths = [480, 800, 1200, 1600], quality = 78) {
  if (shouldSkip(url)) return undefined;
  return widths.map((w) => `${img(url, w, quality)} ${w}w`).join(', ');
}

// Helper for background-image CSS — wraps in url() too.
export function bg(url, width = 1400, quality = 70) {
  return `url(${img(url, width, quality)})`;
}
